import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import CloseIcon from "../../assets/icons/close-icon";
import AddButton, { DraftButton } from "../buttons/button";

const ConfirmModal = ({
  isOpen,
  title = "Are you sure?",
  message = "",
  confirmText = "Yes",
  cancelText = "No",
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  return (
    <Transition show={isOpen ? true : false} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={onCancel}>
        <div className="flex items-center justify-center min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="mx-auto w-full max-w-md my-8 p-6 text-left align-middle transition-all transform bg-white shadow-xl rounded-md">
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-medium leading-6 text-gray-900">{title}</h2>
                <button
                  className="close-button bg-transparent border-none p-0 hover:bg-787878"
                  onClick={onCancel}
                >
                  <CloseIcon />
                </button>
              </div>

              {message && <p className="mt-4 text-sm text-gray-600">{message}</p>}

              <div className="flex justify-end gap-3 items-center mt-6">
                <DraftButton
                  className="text-primary border border-primary border-solid px-6 py-2 items-center rounded-md flex justify-center fw_500 text-sm"
                  onclkFn={onCancel}
                  text={cancelText}
                />
                <AddButton
                  onclkFn={onConfirm}
                  type="button"
                  className="bg-primary text-white px-6 py-2 rounded flex items-center justify-center fw_500 text-sm"
                  text={confirmText}
                  prefixIcon={false}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmModal;
